import './team-slider.scss';
import Swiper from 'swiper/bundle';

export default () => {
	// Desktop Swiper
	new Swiper('.js-team-slider', {
		speed: 500,
		loop: true,
		slidesPerView: 1.2,
		spaceBetween: 20,
		centeredSlides: true,
		navigation: {
			nextEl: ".team-button-next-desktop",
			prevEl: ".team-button-prev-desktop",
		},
		breakpoints: {
			640: {
				slidesPerView: 2.2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
	});

	// Mobile Swiper
	new Swiper('.js-team-slider-mobile', {
		speed: 500,
		loop: true,
		slidesPerView: 1.2,
		spaceBetween: 20,
		centeredSlides: true,
		navigation: {
			nextEl: ".team-button-next-mobile",
			prevEl: ".team-button-prev-mobile",
		},
	});
};
